/**
 * Estimate potential annual revenue uplift from assessment scores.
 * @param {Object} scores - { categories: {...}, overall: number }
 * @param {Object} opts - { avgCheck, seats, turnsPerDay, daysPerYear }
 * @returns {Object} { baseRevenue: number, potentialRevenue: number, uplift: number }
 */
export function calculateRevenueLift(scores, opts = {}) {
  const {
    avgCheck = 40,      // default $40 per guest
    seats = 60,         // default 60 seats
    turnsPerDay = 1.5,  // default 1.5 turns/day
    daysPerYear = 360,  // default ~360 days
  } = opts;

  const guestVolume = seats * turnsPerDay * daysPerYear;
  const baseRevenue = guestVolume * avgCheck;

  // Each 10-point improvement in overall score ≈ 2% revenue uplift; cap at 20%
  const overall = Number(scores?.overall ?? 0);
  const gap = Math.max(0, 100 - (Number.isFinite(overall) ? overall : 0));
  const percentUplift = Math.min(20, (gap / 10) * 2);

  const potentialRevenue = baseRevenue * (1 + percentUplift / 100);
  const uplift = potentialRevenue - baseRevenue;

  return { baseRevenue, potentialRevenue, uplift };
}
